var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('img',{staticClass:"browser-more-img",attrs:{"src":_vm.img(("browser-more/" + _vm.name + ".png")),"height":_vm.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }